import { makeAutoObservable } from 'mobx'
import { type IParamsOrganizationQuietHours } from 'entities/Organization/api/types'
import { formatTimeTo12Hour } from 'entities/QuietHours'
import {
  QUIET_HOURS_ALLOWED_TIME_FROM,
  QUIET_HOURS_ALLOWED_TIME_TO,
} from 'entities/QuietHours/lib/constants'

export type IQuietHours = QuietHours

export class QuietHours {
  private _is_active = false
  private _is_block_on_weekend = false
  private _allowed_time_from = QUIET_HOURS_ALLOWED_TIME_FROM
  private _allowed_time_to = QUIET_HOURS_ALLOWED_TIME_TO

  constructor(private _origin: IParamsOrganizationQuietHours | null | undefined) {
    makeAutoObservable(this)
    if (_origin) this.syncOrigin(_origin)
  }

  get isQuietHoursEnabled() {
    return this._is_active
  }

  get isQuietHoursBlockOnWeekend() {
    return this._is_block_on_weekend
  }

  get quietHoursAllowedTimeFrom() {
    return this._allowed_time_from
  }

  get quietHoursAllowedTimeTo() {
    return this._allowed_time_to
  }

  get formatedQuietHours() {
    const allowedTimeFrom = formatTimeTo12Hour(this._allowed_time_from)
    const allowedTimeTo = formatTimeTo12Hour(this._allowed_time_to)

    return {
      isActive: this.isQuietHoursEnabled,
      isBlockOnWeekend: this.isQuietHoursBlockOnWeekend,
      allowedTimeFrom,
      allowedTimeTo,
    }
  }

  syncOrigin(origin: IParamsOrganizationQuietHours) {
    this._is_active = origin.is_active
    this._is_block_on_weekend = origin.is_block_on_weekend
    this._allowed_time_from = origin.allowed_time_from
    this._allowed_time_to = origin.allowed_time_to
  }
}
